export const SelectForm = ({
  label,
  options,
  labelKey,
  validation,
  submit,
  name,
  value,
  onInputChange,
}) => {
  return (
    <>
      <label className="form-label mb-0">{label}</label>
      <select
        name={name}
        value={value}
        onChange={onInputChange}
        className={`form-select form-control ${
          validation && submit && "border-danger"
        }`}
      >
        <option value={""} disabled={true}>
          Seleccionar
        </option>
        {options.map((option) => (
          <option key={option.id} value={option.id}>
            {option[labelKey]}
          </option>
        ))}
      </select>
      {validation && submit && (
        <span className="text-danger">{validation}</span>
      )}
    </>
  );
};
